export default __webpack_public_path__ + "static/media/Coinbase1.164d11ae.png";